export const optionsSizeStyle = {
    xs: 'text-xs p-2',
    sm: 'text-sm py-2 px-4',
    default: 'text-sm py-2 px-4',
    lg: 'text-sm py-2 px-4',
    noValue: 'text-sm py-2 px-4',
    noPadding: 'text-sm py-2 px-4'
} as const;

export const sizeVariants = {
    xs: 'h-8 text-xs',
    sm: 'py-2 text-sm',
    default: 'rounded-md text-sm min-h-12',
    lg: 'rounded-md text-sm min-h-12',
    noValue: 'p-0',
    noPadding: 'rounded-md text-sm min-h-12 pl-1 pr-9'
} as const;

export const buttonVariants = {
    default:
        'border border-icoGray-300 dark:border-icoDarkMode-beton bg-white dark:bg-icoDarkMode-anthracite focus:border-icoBlue focus:ring-icoBlue-200',
    noBorder: 'bg-white dark:bg-icoDarkMode-anthracite focus:border-icoBlue focus:ring-icoBlue-200',
    grayNoBorder: 'bg-icoGray-100 dark:bg-icoDarkMode-deepBlack',
    grayNoBorderLighter: 'bg-icoGray-100 dark:bg-icoDarkMode-anthracite',
    whiteNoBorder: 'bg-white dark:bg-icoDarkMode-deepBlack',
    whiteWithBorder:
        'bg-white dark:bg-icoDarkMode-deepBlack border border-icoGray-300 dark:border-icoDarkMode-beton',
    grayBackground:
        'border border-icoGray-300 dark:border-icoDarkMode-beton bg-icoGray-100 py-[0.7rem] dark:bg-icoDarkMode-deepBlack focus:border-icoBlue focus:ring-icoBlue-200',
    transparentBackground: 'border-none bg-transparent text-xl',
    lightBorder: 'border border-icoGray-300 dark:border-icoDarkMode-deepBlack'
} as const;

export const selectPlacement = {
    bottom: 'mt-1',
    top: 'mb-1 bottom-full'
} as const;

export const optionWrapperSizeStyle = {
    xs: 'text-xs',
    default: 'text-sm'
} as const;
